var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.visiable, width: "600px" },
      on: {
        "update:visible": function ($event) {
          _vm.visiable = $event
        },
      },
    },
    [
      _c("template", { slot: "title" }, [
        _vm._v(
          _vm._s(
            _vm.isEdit
              ? _vm.$t("customer::customer-list::edit_customer")
              : _vm.$t("customer::customer-list::add_customer")
          )
        ),
      ]),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                rules: _vm.formRules,
                model: _vm.detail,
                "label-width": "80px",
                "status-icon": true,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customer::customer-list::last_name"),
                    prop: "lastName",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "20", "show-word-limit": "" },
                    model: {
                      value: _vm.detail.lastName,
                      callback: function ($$v) {
                        _vm.$set(_vm.detail, "lastName", $$v)
                      },
                      expression: "detail.lastName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customer::customer-list::first_name"),
                    prop: "firstName",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "20", "show-word-limit": "" },
                    model: {
                      value: _vm.detail.firstName,
                      callback: function ($$v) {
                        _vm.$set(_vm.detail, "firstName", $$v)
                      },
                      expression: "detail.firstName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customer::customer-list::email"),
                    prop: "email",
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.detail.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.detail, "email", $$v)
                      },
                      expression: "detail.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customer::customer-list::phone"),
                    prop: "phone",
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.detail.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.detail, "phone", $$v)
                      },
                      expression: "detail.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customer::customer-list::customer_level"),
                    prop: "customerLevel",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t(
                          "customer::customer-list::customer_level_select"
                        ),
                        "popper-append-to-body": false,
                      },
                      model: {
                        value: _vm.detail.customerLevel,
                        callback: function ($$v) {
                          _vm.$set(_vm.detail, "customerLevel", $$v)
                        },
                        expression: "detail.customerLevel",
                      },
                    },
                    _vm._l(_vm.levelList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("customer::customer-list::tag"),
                    prop: "customerTagIds",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t(
                          "customer::customer-list::select_tag"
                        ),
                        multiple: "",
                        "collapse-tags": "",
                        "multiple-limit": 10,
                        "popper-append-to-body": false,
                      },
                      model: {
                        value: _vm.detail.customerTagIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.detail, "customerTagIds", $$v)
                        },
                        expression: "detail.customerTagIds",
                      },
                    },
                    _vm._l(_vm.tagList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visiable = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("customer::customer-list::cancel")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v(_vm._s(_vm.$t("customer::customer-list::confirm")))]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }